<template>
    <div>
        <page-title>插件版本</page-title>
        <page-body>
            <div style="margin-bottom: 20px;" flex="cross:center" v-if="plugin">
                <div style="margin-right: 10px;">
                    <img :src="plugin.pic_url"
                         style="width: 40px;height: 40px;border-radius: 3px; display: block;">
                </div>
                <div style="line-height: 1.45;height: 40px;" flex="dir:top box:last">
                    <div>{{plugin.display_name}}</div>
                    <div style="font-size: 12px;color: #909399;">{{plugin.name}}</div>
                </div>
            </div>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link :to="'/dashboard/admin/plugin/version-edit?plugin_id=' + pluginId">新增版本
                        </router-link>
                    </div>
                    <div></div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="version" label="版本号"></el-table-column>
                <el-table-column prop="update_time" label="更新时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <router-link v-if="scope.row.is_delete === 0"
                                     :to="'/dashboard/admin/plugin/version-edit?id='
                                        + scope.row.id
                                        + '&plugin_id='
                                        + scope.row.plugin_id">编辑
                        </router-link>
                        <span v-else style="color: #999">已删除</span>
                        <span class="text-split">|</span>
                        <el-button v-if="scope.row.is_delete === 0" type="text" @click="deleteItem(scope.row)">删除
                        </el-button>
                        <el-button v-else type="text" @click="recoveryItem(scope.row)">恢复</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>

<style scoped>
    @media screen and (max-width: 767px) {
        .cell div {
            display: block !important;
        }

        .cell div div {
            margin-left: 0 !important;
            text-align: center;
        }
    }
</style>

<script>
import axios from '@/axios'
import helper from '@/helper'

export default {
    name: 'Version',
    data() {
        return {
            loading: false,
            list: null,
            pagination: null,
            keyword: '',
            pluginId: null,
            plugin: null
        }
    },
    created() {
        this.pluginId = this.$route.query.plugin_id
        this.loadData(0)
    },
    methods: {
        loadData(page) {
            this.getList(page).then(e => {
                this.plugin = e.plugin
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/plugin-version/index',
                    params: {
                        page: page,
                        keyword: this.keyword,
                        plugin_id: this.pluginId
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        deleteItem(item) {
            new Promise(resolve => {
                this.$confirm('确认删除该内容?', '提示', {
                    type: 'warning'
                }).then(() => {
                    resolve(item)
                }).catch(() => {
                })
            }).then(item => {
                const data = helper.clone(item)
                data.is_delete = 1
                this.loading = true
                axios({
                    url: 'admin/plugin-version/edit',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                        item.is_delete = 1
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        recoveryItem(item) {
            const data = helper.clone(item)
            data.is_delete = 0
            this.loading = true
            axios({
                url: 'admin/plugin-version/edit',
                method: 'post',
                data: data
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.$message.success(e.data.msg)
                    item.is_delete = 0
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        }
    }
}
</script>
